import React from 'react';
import RightButtons from './rightButtons';

class Details extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            copied:false,
            sendingEmail:false
        }
    }



    onChange(field,value) {
        console.log( field, value )
    }

    render() {

        let me = this
        if ( this.state.copied ) {
            setTimeout(()=>{
                me.setState({copied:false})
            },1000)
        }

        let params = this.props.devis.params
        let getParam = key=>(typeof(key)==='function')?key(params):params[key]
        let content = Object.entries( Details.display ).map( entry=>{
            let rows = entry[1].map(e=>{
                let value = getParam(e[1])
                if ( e.length>=3 ) {
                    if ( typeof(e[2]) === 'function' ) {
                        if ( ! e[2](params) ) return ''
                    }
                    switch ( e[2] ) {
                        case 'bool':
                            value = (value=='O') ? 'Oui' : 'Non'
                            break
                        case 'boolyes':
                            value = (value=='O') ? 'Oui' : 'Non'
                            if ( value == 'Non' ) return ''
                            break
                        case 'nonempty':
                            if ( ! value ) return ''
                            break
                    }
                }
                return <div key={e[1]} className="details_entry"><label>{e[0]}</label><span>{value}</span></div>
            })
            return <div key={entry[0]} className="details_section"><h2>{entry[0]}</h2>
                {rows}
                </div>
        } )

        return <div className="details">
            {content}
            <RightButtons {...this.props}/>
        </div>
    }
}

Details.display = {
    'Vehicule':[
        ['Marque','marque'],
        ['Modèle','modele'],
        ['Cylindrée','cylindree'],
        ['Mise en circulation','date_mise_en_circulation'],
        ['Acquisition','date_acquisition'],
        ['Assuré + 23 mois pour ce véhicule','assur_23_mois','bool'],
        ['Permis',params=>`${params['categorie_permis']} le ${params['date_obtention_permis']}`],
        ['Permis A2',params=>`Permis A2 le ${params['date_obtention_permis_A2']}`,params=>(params['aussi_permis_A2']=='O')],
        ['Bridée pour cette catégorie de permis','bridee_47_5CV','bool'],
        ['24 mois d\'expérience sur une 400 cm3','antecedant_400cm3_24mois','boolyes'],
        ['Assuré actuellement','assure_actuellement','bool']
        
    ], 'Client':[
        ['Civilité','civilite'],
        ['Nom','nom'],
        ['Prénom','prenom'],
        ['Chez','chez','nonempty'],
        ['Adresse','adresse'],
        ['','adresse2','nonempty'],
        ['Code postal','code_postal'],
        ['Ville','ville'],
        ['Téléphone','telephone'],
        ['Email','email'],
        ['Date de naissance','date_naissance'],
        ['Coefficient auto','coefficient_auto'],
        ['Coefficient moto','coefficient_moto'],
        ['Bonus 50 depuis plus de 3 ans','bonus_50_plus_3_ans','bool'],
        ['Assuré 12 mois parmis les 36 derniers mois','assure_12_sur_36','bool']
    ], 'Antécédants':[
        ['Retrait','ant_retrait','bool'],
        ['Date retrait','ant_retrait_date','nonempty'],
        ['Durée du retrait (mois)','ant_retrait_duree_mois','nonempty'],
        ['Motif du retrait',params=>{ 
            return {
                '':'',
                'RETRA':'Excès de vitesse',
                'REFUS':'Refus d\'obtempérer',
                'FUITE':'Délit de fuite',
                'AUTRE':'Autre'
            }[params['ant_retrait_motif']] },'nonempty'],
        ['Est-ce une récidive','ant_retrait_recidive','boolyes'],
        ['Annulation de permis','ant_annulation','bool'],
        ['Date d\'annulation','ant_annulation_date','nonempty'],
        ['Sanction en état d\'ébriété','ant_alcool','bool'],
        ['Date sanction','ant_alcool_date','nonempty'],
        ['Condamnation pour conduite sous stupéfiants','ant_stupefiants','bool'],
        ['Date condamnation','ant_stupefiants_date','nonempty'],
        ['Résiliation par un précédent assureur','ant_resiliation','bool'],
        ['Date résiliation','ant_resiliation_date','nonempty'],
        ['Résiliation pour non paiement','ant_resiliation_non_paiement','boolyes'],
        ['Résiliation pour fausse déclaration','ant_resiliation_fausse_declaration','boolyes'],
        ['Résiliation pour fréquence sinistres','ant_resiliation_frequence_sinistres','boolyes'],
        ['Résiliation pour autre motif','ant_resiliation_autre_motif','boolyes'],
        ['Sinistres non responsables','sinistres_nr','bool'],
        ['Dates','sinistres_nr_date1','nonempty'],
        ['','sinistres_nr_date2','nonempty'],
        ['','sinistres_nr_date3','nonempty'],
        ['','sinistres_nr_date4','nonempty'],
        ['','sinistres_nr_date5','nonempty'],
        ['','sinistres_nr_date6','nonempty'],
        ['','sinistres_vi_date1','nonempty'],
        ['','sinistres_vi_date2','nonempty'],
        ['','sinistres_vi_date3','nonempty'],
        ['','sinistres_vi_date4','nonempty'],
        ['','sinistres_vi_date5','nonempty'],
        ['','sinistres_vi_date6','nonempty'],
        ['Sinistres matériels responsables','sinistres_mr','bool'],
        ['Dates','sinistres_mr_date1','nonempty'],
        ['','sinistres_mr_date2','nonempty'],
        ['','sinistres_mr_date3','nonempty'],
        ['','sinistres_mr_date4','nonempty'],
        ['','sinistres_mr_date5','nonempty'],
        ['Sinistres corporels responsables','sinistres_cr','bool'],
        ['Dates','sinistres_cr_date1','nonempty'],
        ['','sinistres_cr_date2','nonempty']
    ]
}

export default Details;
